import {
  IAccount,
  IAccountService,
  IProperty,
  IPropertySelection,
  IUserContext,
} from "@origin-digital/event-dispatcher";
import { mapToAccountServices } from "./mapAccountServices";

interface PropertyAccounts {
  property: IProperty;
  accounts: IAccount[];
}

const getPropertyAccountGroups = (accounts: IAccount[]): PropertyAccounts[] => {
  const propertyIdToGroup: Record<string, PropertyAccounts> = {};
  accounts.forEach((account) => {
    account.services.forEach((service) => {
      if (!propertyIdToGroup[service.property.id]) {
        propertyIdToGroup[service.property.id] = {
          property: service.property,
          accounts: [],
        };
      }
      if (!propertyIdToGroup[service.property.id].accounts.includes(account)) {
        propertyIdToGroup[service.property.id].accounts.push(account);
      }
    });
  });
  return Object.values(propertyIdToGroup);
};

/**
 * Create a list of possible property selections for the given user data.
 * Each property is a grouping containing a single property and a collection of account-service combinations for that property.
 */
export const mapUserDataToProperties = (
  userContext?: IUserContext
): IPropertySelection[] => {
  if (!userContext) {
    return [];
  }

  const propertyAccountGroups = getPropertyAccountGroups(userContext.accounts);

  return propertyAccountGroups
    .map(({ property, accounts }) => {
      const accountServices: IAccountService[] = mapToAccountServices(
        accounts,
        property.id
      );
      return {
        ...property,
        accountServices,
        selectedAccountService: accountServices[0],
        isPrevious: accountServices.every(
          (accountService) => accountService.isClosed
        ),
      };
    })
    .filter((property) => property.accountServices.length);
};
